export default function getStyleSize(size: number | string) {
  if (typeof size === 'undefined') {
    return;
  }
  return typeof size === 'string' ? size : size + 'rem';
}
